import React from 'react';
import {
    ADD_CASE,
    BANK_LIST,
    CAR_BRAND,
    CAR_MODEL,
    CAR_VARIANT,
    CASE_BY_ID,
    CASE_LIST,
    CASES_BY_LSQ_DEALER_ID,
    CASES_STATUS_UPDATE,
    LOAN_ACCOUNTS,
    LOAN_APPLICATION_BY_ID,
    LOAN_APPLICATION_UPDATE,
    LOAN_UNDERTAKING,
    PAYMENT_RAISE,
    UCD_LIST,
    UCD_VIEW,
    LOAN_PAYMENT_REQUEST,
    LOAN_TRANCHES,
    UPDATE_TRANCHE_STATUS,
    PAYMENT_RAISE_UPDATE,
    ACCOUNT_PENNY_DROP,
    APPROVAL_REQUEST,
    BANK_SHEET_UPLOAD,
    GET_PAYOUT_DETAILS,
    UPDATE_PAYOUT_DETAILS,
    GET_ACCOUNT_DETAILS,
    NEW_BANK_DETAILS,
    PAYOUT_CONFIGURATION_LIST,
    PAYOUT_CONFIGURATION_VERIFY,
    B2C_LEAD,
    FORE_CLOSURE_ACCOUNT,
    VEHICLE_DETAILS,
    UPDATE_LOAN_APPLICATION_FOR_B2C,
    B2C_CASE_LOGIN_WITHOUT_DEALER,
    RC_CASE_LISTING,
    RC_CASE_BY_ID, RTO_DETAILS_UPDATE,
    COMMISSION_PAYOUT_CASE_LIST,
    VALIDATE_INVOICE_STATUS,
    PREVIEW_INVOICE,
    RAISE_INVOICE,
    CAR_BRAND_FOR_B2C,
    CAR_MODEL_FOR_B2C
} from "./type";

const initalState = {
    ucdListResponse: [],
    ucdViewResponse: [],
    addCaseResponse: [],
    caseListResponse: [],
    caseByIdResponse: [],
    carBrandResponse: [],
    carModelResponse: [],
    carVariantResponse: [],
    bankListResponse: [],
    caseByLsqDealerIdResponse: [],
    caseStatusUpdateResponse: [],
    loanApplicationByIdResponse: [],
    loanApplicationUpdateResponse: [],
    loanPaymentRaiseResponse: [],
    loanAccountResponse: [],
    loanUndertakingResponse: [],
    loanTranchesResponse: [],
    loanPaymentRequestResponse: [],
    updateTrancheStatusResponse: [],
    loanPaymentRaiseUpdateResponse: [],
    accountPennyDropResponse: [],
    loanApprovalRequestResponse: [],
    uploadTheBankSheet: [],
    getAllThePayoutDetailsWithId: [],
    updatePayoutDetailsWithId: [],
    getPayoutAccountDetailsWithId: [],
    newBankDetailsResponse: [],
    payoutConfigurationListResponse: [],
    payoutConfigurationVerifyResponse: [],
    b2cLeadListResponse: [],
    vehicleDetailsResponse: [],
    updateb2cloanapplication: [],
    addB2cCaseLoginWithDealerResponse: [],
    rcCaseListingResponse: [],
    rcCaseByIdResponse: [],
    rtoDetailsUpdateResponse: [],
    commissionPayoutResponse: [],
    validateStatusResponse: [],
    previewInvoiceResponse: [],
    raiseInvoiceResponse: [],
    carBrandForB2cResponse: [],
    carModelForB2cResponse: []
};

const CarLoan = (state = initalState, action) => {
    const {type, payload} = action;
    switch (type) {
        case UCD_LIST:
            return {
                ...state,
                ucdListResponse: payload,
            };
        case UCD_VIEW:
            return {
                ...state,
                ucdViewResponse: payload,
            };
        case ADD_CASE:
            return {
                ...state,
                addCaseResponse: payload,
            };
        case CASE_LIST:
            return {
                ...state,
                caseListResponse: payload,
            };
        case CASE_BY_ID:
            return {
                ...state,
                caseByIdResponse: payload,
            };
        case CAR_BRAND:
            return {
                ...state,
                carBrandResponse: payload,
            };
        case CAR_MODEL:
            return {
                ...state,
                carModelResponse: payload,
            };
        case CAR_VARIANT:
            return {
                ...state,
                carVariantResponse: payload,
            };
        case BANK_LIST:
            return {
                ...state,
                bankListResponse: payload,
            };
        case CASES_BY_LSQ_DEALER_ID:
            return {
                ...state,
                caseByLsqDealerIdResponse: payload,
            };
        case CASES_STATUS_UPDATE:
            return {
                ...state,
                caseStatusUpdateResponse: payload,
            };
        case LOAN_APPLICATION_BY_ID:
            return {
                ...state,
                loanApplicationByIdResponse: payload,
            };
        case LOAN_APPLICATION_UPDATE:
            return {
                ...state,
                loanApplicationUpdateResponse: payload,
            };
        case PAYMENT_RAISE:
            return {
                ...state,
                loanPaymentRaiseResponse: payload,
            };
        case LOAN_ACCOUNTS:
            return {
                ...state,
                loanAccountResponse: payload,
            };
        case LOAN_UNDERTAKING:
            return {
                ...state,
                loanUndertakingResponse: payload,
            };
        case LOAN_TRANCHES:
            return {
                ...state,
                loanTranchesResponse: action.payload,
            };
        case LOAN_PAYMENT_REQUEST:
            return {
                ...state,
                loanPaymentRequestResponse: action.payload,
            };
        case UPDATE_TRANCHE_STATUS:
            return {
                ...state,
                updateTrancheStatusResponse: action.payload,
            };
        case PAYMENT_RAISE_UPDATE:
            return {
                ...state,
                loanPaymentRaiseUpdateResponse: action.payload,
            };
        case ACCOUNT_PENNY_DROP:
            return {
                ...state,
                accountPennyDropResponse: action.payload,
            };
        case APPROVAL_REQUEST:
            return {
                ...state,
                loanApprovalRequestResponse: payload,
            };
        case BANK_SHEET_UPLOAD:
            return {
                ...state,
                uploadTheBankSheet: payload,
            };
        case GET_PAYOUT_DETAILS:
            return {
                ...state,
                getAllThePayoutDetailsWithId: payload,
            };
        case UPDATE_PAYOUT_DETAILS:
            return {
                ...state,
                updatePayoutDetailsWithId: payload,
            };
        case GET_ACCOUNT_DETAILS:
            return {
                ...state,
                getPayoutAccountDetailsWithId: payload,
            };
        case NEW_BANK_DETAILS:
            return {
                ...state,
                newBankDetailsResponse: action.payload,
            };
        case PAYOUT_CONFIGURATION_LIST:
            return {
                ...state,
                payoutConfigurationListResponse: action.payload,
            };
        case PAYOUT_CONFIGURATION_VERIFY:
            return {
                ...state,
                payoutConfigurationVerifyResponse: action.payload,
            };
        case B2C_LEAD:
            return {
                ...state,
                b2cLeadListResponse: payload,
            };
        case FORE_CLOSURE_ACCOUNT:
            return {
                ...state,
                foreClosureAddAccountResponse: payload,
            };
        case VEHICLE_DETAILS:
            return {
                ...state,
                vehicleDetailsResponse: action.payload,
            };
        case UPDATE_LOAN_APPLICATION_FOR_B2C:
            return {
                ...state,
                updateb2cloanapplication: action.payload,
            };
        case B2C_CASE_LOGIN_WITHOUT_DEALER:
            return {
                ...state,
                addB2cCaseLoginWithDealerResponse: action.payload,
            };
        case RC_CASE_LISTING:
            return {
                ...state,
                rcCaseListingResponse: action.payload,
            };
        case RC_CASE_BY_ID:
            return {
                ...state,
                rcCaseByIdResponse: action.payload,
            };
        case RTO_DETAILS_UPDATE:
            return {
                ...state,
                rtoDetailsUpdateResponse: action.payload,
            };
        case COMMISSION_PAYOUT_CASE_LIST:
            return {
                ...state,
                commissionPayoutResponse: action.payload,
            };
        case VALIDATE_INVOICE_STATUS:
            return {
                ...state,
                validateStatusResponse: action.payload,
            };
        case PREVIEW_INVOICE:
            return {
                ...state,
                previewInvoiceResponse: action.payload,
            };
        case RAISE_INVOICE:
            return {
                ...state,
                raiseInvoiceResponse: action.payload,
            };
        case CAR_BRAND_FOR_B2C:
            return {
                ...state,
                carBrandForB2cResponse: action.payload,
            };
        case CAR_MODEL_FOR_B2C:
            return {
                ...state,
                carModelForB2cResponse: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default CarLoan
